import {createAction} from '@reduxjs/toolkit';

import type {ClientThread} from '../types/extended';

export const setSelectedThreadId = createAction<ClientThread['id']>('threads/actions/setSelectedThreadId');
